// this module provides a workaround for debounce hardly workable in jest tests
// when running tests this module returns a function that simply calls it's callback when invoked
import debounce from 'debounce-promise';


const noopDebounce = (func) => {
  return (...args) => {
    return func(...args);
  };
};

const debounceFunc = RUNTESTS_ENV ? noopDebounce : debounce;

export default debounceFunc;
